import { Avatar, Box, HStack, Text } from '@chakra-ui/react';
import { useMe } from '@/hooks/auth/useMe';
import Tooltip from '@/components/Tooltip';

interface Props {
  isCollapsed?: boolean;
}

const UserProfile = ({ isCollapsed }: Props) => {
  const { data: user } = useMe();

  if (!user) return null;

  const emailCut = user.email.length > 19
    ? `${user.email.slice(0, 19)}...`
    : user.email;

  if (isCollapsed) {
    return (
      <Tooltip content={user.name} positioning={{ placement: 'right' }} showArrow>
        <Box display="flex" justifyContent="center" cursor="default">
          <Avatar.Root>
            <Avatar.Image src={user.avatar_url ?? undefined} />
            <Avatar.Fallback />
          </Avatar.Root>
        </Box>
      </Tooltip>
    );
  }

  return (
    <HStack gap="3" justify="space-between">
      <HStack gap="3">
        <Avatar.Root>
          <Avatar.Image src={user.avatar_url ?? undefined} />
          <Avatar.Fallback />
        </Avatar.Root>
        <Box>
          <Text textStyle="sm" fontWeight="medium">
            {user.name}
          </Text>
          <Tooltip content={user.email} showArrow>
            <Text textStyle="sm" color="fg.muted">
              {emailCut}
            </Text>
          </Tooltip>
        </Box>
      </HStack>
    </HStack>
  );
};

export default UserProfile;
